import Vue from 'vue';
import API from './index';

Vue.prototype.$http = API;

// declare module 'vue/types/vue' {
//   interface Vue {
//         $http: {
//             [key: string]: AxiosStatic;
//         }
//     }
//   }